import { forwardRef, Ref } from "react";
import clsx from "clsx";

import { FieldWrapper, FieldWrapperPassThroughProps } from "./FieldWrapper";
import { UseFormRegisterReturn } from "react-hook-form";

export interface RadioOption {
  label: string;
  value: string;
}

export type RadioButtonFieldProps = FieldWrapperPassThroughProps & {
  name: string;
  options: RadioOption[];
  registration: Partial<UseFormRegisterReturn>;
  className?: string;
};

export const RadioButtonField = forwardRef<HTMLDivElement, RadioButtonFieldProps>(
  ({ name, options, registration, className, label, error, leftAddon, ...rest }, ref: Ref<HTMLDivElement>) => {
    return (
      <FieldWrapper label={label} error={error} leftAddon={leftAddon}>
        <div ref={ref} className="flex flex-row space-x-4">
          {options.map((option) => (
            <label key={option.value} className="inline-flex items-center">
              <input
                type="radio"
                name={name}
                value={option.value}
                {...registration}
                className={clsx("form-radio h-4 w-4 text-blue-600 transition duration-150 ease-in-out", className)}
                {...rest}
              />
              <span className="ml-2 text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      </FieldWrapper>
    );
  }
);

RadioButtonField.displayName = "RadioButtonField";
